/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CartItemComponent, CartItemContextSource } from '@spartacus/cart/base/components';
import { CartItemComponentOptions, CartItemContext, OrderEntry, PromotionLocation } from '@spartacus/cart/base/root';
import { ICON_TYPE, OutletDirective, MediaComponent, PromotionsComponent, AtMessageDirective } from '@spartacus/storefront';
import { FeatureLevelDirective, TranslatePipe, UrlPipe } from '@spartacus/core';
import { Ubxb2bCartItemValidationWarningComponent } from '../../../validation/cart-item-validation-warning/cart-item-validation-warning.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Udxb2bItemCounterComponent } from '../../item-counter/item-counter.component';

@Component({
    selector: 'cx-cart-item',
    templateUrl: './cart-item.component.html',
    providers: [CartItemContextSource, { provide: CartItemContext, useExisting: CartItemContextSource }],
    imports: [OutletDirective, FeatureLevelDirective, Ubxb2bCartItemValidationWarningComponent, NgClass, RouterLink, MediaComponent, Udxb2bItemCounterComponent, PromotionsComponent, NgTemplateOutlet, AtMessageDirective, TranslatePipe, UrlPipe]
})
export class UdxCartItemComponent extends CartItemComponent implements OnChanges {
  @Input() override compact = false;
  @Input() override item!: OrderEntry;
  @Input() override readonly = false;
  @Input() override quantityControl!: UntypedFormControl;

  @Input() override promotionLocation: PromotionLocation = PromotionLocation.ActiveCart;

  // TODO: evaluate whether this is generic enough
  @Input() override options: CartItemComponentOptions = {
    isSaveForLater: false,
    optionalBtn: null,
    displayAddToCart: false,
  };

  override iconTypes = ICON_TYPE;

  constructor(cartItemContextSource: CartItemContextSource) {
    super(cartItemContextSource);
  }

  override ngOnChanges(changes?: SimpleChanges) {
    if (changes?.['compact']) {
      this.cartItemContextSource.compact$.next(this.compact);
    }
    if (changes?.['readonly']) {
      this.cartItemContextSource.readonly$.next(this.readonly);
    }
    if (changes?.['item']) {
      this.cartItemContextSource.item$.next(this.item);
    }
    if (changes?.['quantityControl']) {
      this.cartItemContextSource.quantityControl$.next(this.quantityControl);
    }
    if (changes?.['promotionLocation']) {
      this.cartItemContextSource.location$.next(this.promotionLocation);
    }
    if (changes?.['options']) {
      this.cartItemContextSource.options$.next(this.options);
    }
  }

  override isProductOutOfStock(product: any): boolean {
    // TODO Move stocklevelstatuses across the app to an enum
    return product && product.stock && product.stock.stockLevelStatus === 'outOfStock';
  }

  override removeItem() {
    this.quantityControl.setValue(0);
    this.quantityControl.markAsDirty();
  }
}
